/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<g opacity="0.4">
				<path
					d="M12 20C12 21.1046 11.1046 22 10 22C8.89543 22 8 21.1046 8 20C8 18.8954 8.89543 18 10 18C11.1046 18 12 18.8954 12 20Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
				/>
				<path
					d="M20 20C20 21.1046 19.1046 22 18 22C16.8954 22 16 21.1046 16 20C16 18.8954 16.8954 18 18 18C19.1046 18 20 18.8954 20 20Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
				/>
			</g>
			<path
				d="M1 1.00006L1.5 1V1C1.72586 1.00001 1.83878 1.00001 1.94018 1.00689C3.12785 1.08748 4.15552 1.86267 4.55926 2.98252C4.59373 3.07812 4.62476 3.1867 4.6868 3.40387L4.85714 4.00006M4.85714 4.00006L6.67378 10.3583C7.14917 12.0222 7.38687 12.8541 7.87213 13.4716C8.30044 14.0166 8.86305 14.441 9.50478 14.7031C10.2318 15.0001 11.0971 15.0001 12.8275 15.0001H15.1117C16.8624 15.0001 17.7377 15.0001 18.4706 14.6976C19.1174 14.4307 19.6829 13.9988 20.1106 13.445C20.5953 12.8175 20.8256 11.973 21.2862 10.284L21.3465 10.063C21.9086 8.00171 22.1897 6.97105 21.9513 6.15698C21.7425 5.44374 21.2763 4.8334 20.6432 4.44424C19.9205 4.00006 18.8522 4.00006 16.7156 4.00006H4.85714Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path
					d="M12 19.9999C12 21.1045 11.1046 21.9999 10 21.9999C8.89543 21.9999 8 21.1045 8 19.9999C8 18.8954 8.89543 17.9999 10 17.9999C11.1046 17.9999 12 18.8954 12 19.9999Z"
					fill="currentColor"
				/>
				<path
					d="M20 19.9999C20 21.1045 19.1046 21.9999 18 21.9999C16.8954 21.9999 16 21.1045 16 19.9999C16 18.8954 16.8954 17.9999 18 17.9999C19.1046 17.9999 20 18.8954 20 19.9999Z"
					fill="currentColor"
				/>
				<path
					d="M16.7156 4C18.8522 4 19.9205 4 20.6432 4.44418C21.2763 4.83334 21.7425 5.44368 21.9514 6.15692C22.1897 6.97099 21.9086 8.00165 21.3465 10.063L21.2862 10.284C20.8256 11.9729 20.5953 12.8174 20.1106 13.4449C19.6829 13.9987 19.1174 14.4306 18.4706 14.6976C17.7377 15 16.8624 15 15.1117 15H12.8275C11.0971 15 10.2318 15 9.50479 14.703C8.86305 14.4409 8.30045 14.0166 7.87213 13.4715C7.38687 12.854 7.14917 12.0221 6.67378 10.3582L4.85715 4H16.7156Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M1 1.00006L1.5 1V1C1.72586 1.00001 1.83878 1.00001 1.94018 1.00689C3.12785 1.08748 4.15552 1.86267 4.55926 2.98252C4.59373 3.07812 4.62476 3.1867 4.6868 3.40387L4.85714 4.00006M4.85714 4.00006L6.67378 10.3583C7.14917 12.0222 7.38687 12.8541 7.87213 13.4716C8.30044 14.0166 8.86305 14.441 9.50478 14.7031C10.2318 15.0001 11.0971 15.0001 12.8275 15.0001H15.1117C16.8624 15.0001 17.7377 15.0001 18.4706 14.6976C19.1174 14.4307 19.6829 13.9988 20.1106 13.445C20.5953 12.8175 20.8256 11.973 21.2862 10.284L21.3465 10.063C21.9086 8.00171 22.1897 6.97105 21.9513 6.15698C21.7425 5.44374 21.2763 4.8334 20.6432 4.44424C19.9205 4.00006 18.8522 4.00006 16.7156 4.00006H4.85714ZM12 20C12 21.1046 11.1046 22 10 22C8.89543 22 8 21.1046 8 20C8 18.8954 8.89543 18 10 18C11.1046 18 12 18.8954 12 20ZM20 20C20 21.1046 19.1046 22 18 22C16.8954 22 16 21.1046 16 20C16 18.8954 16.8954 18 18 18C19.1046 18 20 18.8954 20 20Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.49998 1.75H1.50007H1.50009C1.73715 1.75001 1.81954 1.75043 1.88941 1.75517C2.78016 1.81561 3.55091 2.39701 3.85372 3.23689C3.87747 3.30278 3.90051 3.38189 3.96566 3.60991L4.136 4.2061L5.95263 10.5643L5.99982 10.7296C6.42913 12.2338 6.70491 13.2001 7.28243 13.935C7.79105 14.5822 8.45914 15.0862 9.2212 15.3974C10.0865 15.7508 11.0914 15.7505 12.6556 15.7501L12.8275 15.7501H15.1117L15.2858 15.7501C16.8681 15.7506 17.8844 15.7509 18.7567 15.3909C19.5248 15.074 20.1963 14.5611 20.7042 13.9034C21.281 13.1566 21.5481 12.176 21.964 10.6493L22.0098 10.4814L22.07 10.2604L22.0796 10.2252L22.0797 10.2251C22.3526 9.22431 22.5707 8.42475 22.6873 7.77477C22.8062 7.1121 22.8381 6.51649 22.6711 5.94622C22.4101 5.05466 21.8273 4.29174 21.0359 3.80528C20.5297 3.49413 19.9466 3.36816 19.276 3.30853C18.6182 3.25005 17.7894 3.25006 16.7521 3.25006H16.7156H5.42287L5.40795 3.19783L5.40044 3.17156C5.34563 2.97966 5.30805 2.84808 5.26481 2.72815C4.76013 1.32834 3.47555 0.35935 1.99096 0.258612C1.86377 0.249982 1.72694 0.24999 1.52739 0.250001H1.52735H1.50002L1.5 1L1.49991 0.250001L0.999908 0.250064C0.585695 0.250114 0.249949 0.585942 0.25 1.00016C0.250051 1.41437 0.585878 1.75011 1.00009 1.75006L1.49998 1.75ZM10 17.25C8.48122 17.25 7.25 18.4812 7.25 20C7.25 21.5188 8.48122 22.75 10 22.75C11.5188 22.75 12.75 21.5188 12.75 20C12.75 18.4812 11.5188 17.25 10 17.25ZM18 17.25C16.4812 17.25 15.25 18.4812 15.25 20C15.25 21.5188 16.4812 22.75 18 22.75C19.5188 22.75 20.75 21.5188 20.75 20C20.75 18.4812 19.5188 17.25 18 17.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9 4.00006H16.7156C18.8522 4.00006 19.9205 4.00006 20.6432 4.44424C21.2763 4.8334 21.7425 5.44374 21.9513 6.15698C22.1897 6.97105 21.9086 8.00171 21.3465 10.063L21.2862 10.284C20.8256 11.973 20.5953 12.8175 20.1106 13.445C19.6829 13.9988 19.1174 14.4307 18.4706 14.6976C17.7377 15.0001 16.8624 15.0001 15.1117 15.0001H12.8275C11.0971 15.0001 10.2318 15.0001 9.50478 14.7031C8.86305 14.441 8.30044 14.0166 7.87213 13.4716C7.38687 12.8541 7.14917 12.0222 6.67378 10.3583L4.6868 3.40387C4.62476 3.18671 4.59373 3.07812 4.55926 2.98252C4.15552 1.86267 3.12785 1.08748 1.94018 1.00689C1.83878 1.00001 1.72586 1.00001 1.5 1V1L1 1.00006M20 20C20 21.1046 19.1046 22 18 22C16.8954 22 16 21.1046 16 20C16 18.8954 16.8954 18 18 18M12 20C12 21.1046 11.1046 22 10 22C8.89543 22 8 21.1046 8 20C8 18.8954 8.89543 18 10 18C11.1046 18 12 18.8954 12 20Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M1 1.00006L1.5 1V1C1.72586 1.00001 1.83878 1.00001 1.94018 1.00689C3.12785 1.08748 4.15552 1.86267 4.55926 2.98252C4.59373 3.07812 4.62476 3.1867 4.6868 3.40387L4.85714 4.00006M4.85714 4.00006L6.67378 10.3583C7.14917 12.0222 7.38687 12.8541 7.87213 13.4716C8.30044 14.0166 8.86305 14.441 9.50478 14.7031C10.2318 15.0001 11.0971 15.0001 12.8275 15.0001H15.1117C16.8624 15.0001 17.7377 15.0001 18.4706 14.6976C19.1174 14.4307 19.6829 13.9988 20.1106 13.445C20.5953 12.8175 20.8256 11.973 21.2862 10.284L21.3465 10.063C21.9086 8.00171 22.1897 6.97105 21.9513 6.15698C21.7425 5.44374 21.2763 4.8334 20.6432 4.44424C19.9205 4.00006 18.8522 4.00006 16.7156 4.00006H4.85714ZM12 20C12 21.1046 11.1046 22 10 22C8.89543 22 8 21.1046 8 20C8 18.8954 8.89543 18 10 18C11.1046 18 12 18.8954 12 20ZM20 20C20 21.1046 19.1046 22 18 22C16.8954 22 16 21.1046 16 20C16 18.8954 16.8954 18 18 18C19.1046 18 20 18.8954 20 20Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.49998 1.75H1.50007H1.50009C1.73715 1.75001 1.81954 1.75043 1.88941 1.75517C2.78016 1.81561 3.55091 2.39701 3.85372 3.23689C3.87747 3.30278 3.90051 3.38189 3.96566 3.60991L4.136 4.2061L5.95263 10.5643L5.99982 10.7296C6.42913 12.2338 6.70491 13.2001 7.28243 13.935C7.79105 14.5822 8.45914 15.0862 9.2212 15.3974C10.0865 15.7508 11.0914 15.7505 12.6556 15.7501L12.8275 15.7501H15.1117L15.2858 15.7501C16.8681 15.7506 17.8844 15.7509 18.7567 15.3909C19.5248 15.074 20.1963 14.5611 20.7042 13.9034C21.281 13.1566 21.5481 12.176 21.964 10.6493L22.0098 10.4814L22.07 10.2604L22.0796 10.2252L22.0797 10.2251C22.3526 9.22431 22.5707 8.42475 22.6873 7.77477C22.8062 7.1121 22.8381 6.51649 22.6711 5.94622C22.4101 5.05466 21.8273 4.29174 21.0359 3.80528C20.5297 3.49413 19.9466 3.36816 19.276 3.30853C18.6182 3.25005 17.7894 3.25006 16.7521 3.25006H16.7156H5.42287L5.40795 3.19783L5.40044 3.17156C5.34563 2.97966 5.30805 2.84808 5.26481 2.72815C4.76013 1.32834 3.47555 0.35935 1.99096 0.258612C1.86377 0.249982 1.72694 0.24999 1.52739 0.250001H1.52735H1.50002L1.5 1L1.49991 0.250001L0.999908 0.250064C0.585695 0.250114 0.249949 0.585942 0.25 1.00016C0.250051 1.41437 0.585878 1.75011 1.00009 1.75006L1.49998 1.75Z"
				fill="currentColor"
			/>
			<path
				d="M10 17.25C8.48122 17.25 7.25 18.4812 7.25 20C7.25 21.5188 8.48122 22.75 10 22.75C11.5188 22.75 12.75 21.5188 12.75 20C12.75 18.4812 11.5188 17.25 10 17.25Z"
				fill="currentColor"
			/>
			<path
				d="M18 17.25C16.4812 17.25 15.25 18.4812 15.25 20C15.25 21.5188 16.4812 22.75 18 22.75C19.5188 22.75 20.75 21.5188 20.75 20C20.75 18.4812 19.5188 17.25 18 17.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
